/* eslint-disable */
import {Filtro} from "../models/filtro/filtro";


export const  getContratoReceberSCH = (campo, valor, condicao)=>{
  var filtro = new Filtro()
  filtro.perPage = 1
  filtro.filters.addFilter(campo,valor,condicao)
  filtro.fields = ['*']
  return filtro
}

export const setFiltroContratoReceberSCH = (perPage, filtro)=> {
  filtro.perPage = perPage
  return filtro
}

export const ContratoReceberSCH = (perPage)=> {
    var filtro = new Filtro()
    filtro.perPage = perPage
    filtro.fields = ['*']
    return filtro
}

export const ContratoReceber2SCH = (perPage)=> {
    var filtro = new Filtro()
    filtro.perPage = perPage
    filtro.fields = ['*']
  return filtro
}
